import React, { createContext, useState, useContext, useEffect } from "react";

import { getStoredState, updateStoredState } from "../utils/localStorage";

const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const [role, setRole] = useState(() => getStoredState()?.role || "");

  useEffect(() => {
    updateStoredState({ role });
  }, [role]);

  return (
    <RoleContext.Provider value={{ role, setRole }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
